export default ({request}) => ({
  masterContainerListApi(data = {}) {
    return request({
      url: '/factory/masterContainer/list',
      method: 'post',
      data,
    })
  },
  masterContainerDetailApi(data = {}) {
    return request({
      url: '/factory/masterContainer/detail',
      method: 'post',
      data,
    })
  },
  masterContainerDetailByNameApi(data = {}) {
    return request({
      url: '/factory/masterContainer/detail/byName',
      method: 'post',
      data,
    })
  },
  masterContainerSaveApi(data = {}) {
    return request({
      url: '/factory/masterContainer/save',
      method: 'post',
      data,
    })
  },
  masterContainerDelApi(data = {}) {
    return request({
      url: '/factory/masterContainer/del',
      method: 'post',
      data,
    })
  },
})
